import axios from "axios";

const generateUUID = () => {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
};

export const getUserId = () => {
  let id = localStorage.getItem("poster_picker_uid");
  if (!id) {
    id = generateUUID();
    localStorage.setItem("poster_picker_uid", id);
  }
  return id;
};

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  config.headers["X-User-ID"] = getUserId();
  return config;
});

export default api;
